export default __webpack_public_path__ + "static/glass-2-653f23d48fb1b6743f32b9ef7d0ffb2a.jpg";